<template>
  <div class="app-error">
    <v-dialog max-width="290" persistent v-model="dialog">
      <v-card color="error">
        <v-card-title class="headline">{{ $t("app.error") }}</v-card-title>
        <v-card-text v-if="appError">
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dismiss" color="primary darken-1" text>{{ $t("app.ignore") }}</v-btn>
          <v-btn @click="reload" color="primary darken-1" text>{{ $t("app.reload") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import RootStateMixin from "@/mixins/store/RootStateMixin";
import Component, { mixins } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { ApiError } from "@/api/ApiError";

@Component
export default class AppError extends mixins(RootStateMixin) {
  dialog = false;

  get message(): string {
    return this.appError?.getMessage();
  }

  dismiss(): void {
    this.dialog = false;
    this.resetAppError();
  }

  reload(): void {
    window.location.reload();
  }

  @Watch("appError")
  onAppErrorChanged(newVal: ApiError): void {
    if (newVal && !newVal.isSystemError) {
      this.dialog = true;
    }
  }
}
</script>
